import React from "react";
import Link from "next/link";
import * as s from "../index.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useRouter } from "next/router";

const DesktopSubMenu = ({ subLinks, setToggle }) => {
  const router = useRouter();
  return (
    <div className={`${s.sub_links_desktop} desktop-nav-dropdown`}>
      <Swiper
        slidesPerView={"auto"}
        spaceBetween={12}
        navigation={true}
        modules={[Navigation]}
      >
        {subLinks.map(({ image, link, title }, idx) => {
          return (
            <SwiperSlide
              key={idx}
              className={s.single_slide_link}
              onClick={() => setToggle(false)}
            >
              <Link href={link}>
                <img src={image} loading="lazy" alt="image" height="100%" />
                <p>{title}</p>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {/*<Link*/}
      {/*  href="/what-we-buy"*/}
      {/*  className={`btn btn-outline-dark ${s.see_all}`}*/}
      {/*  onClick={(e) => {*/}
      {/*    e.preventDefault();*/}
      {/*    setToggle(false);*/}
      {/*    router.push("/what-we-buy");*/}
      {/*  }}*/}
      {/*>*/}
      {/*  Things We Buy*/}
      {/*</Link>*/}
    </div>
  );
};

export default DesktopSubMenu;
